import './EpisodesList.scss'
import Slider from "react-slick";
import React, { useEffect, useState } from "react";

import { useRouter } from "../../../hooks/router";
import CardEpisodes from "./CardEpisodes";
import { translateWord } from "../../Util/util";

export default function EpisodesList({ episodes, play_episode_info_field, episodesShow }) {
    const router = useRouter()

    const [loadingEpisodes, setLoadingEpisodes] = useState(false)
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
        // responsive: [
        //     {
        //         breakpoint: 1024,
        //         settings: {
        //             slidesToShow: 3,
        //             slidesToScroll: 3,
        //             infinite: true,
        //             dots: true
        //         }
        //     },
        // ]
    }

    let time_out
    useEffect(() => {
        setLoadingEpisodes(true)

        time_out = setTimeout(() => {
            setLoadingEpisodes(false)
        }, 350)

        return () => clearTimeout(episodes)

    }, [episodes])
    return (
        <div className="list_episodes" style={{ opacity: episodesShow ? '0' : '1' }}>
            <h1>{translateWord('Episodes')}</h1>
            <Slider {...settings}>
                {episodes.map((elem, index) => {
                    return loadingEpisodes ?
                        <img key={index} src={''} alt="" />
                        :
                        <CardEpisodes key={elem.id} play_episode_info_field={play_episode_info_field} elem={elem} />
                })}
            </Slider>
        </div>
    )
}